import useStyles from '@forms/components/application_styles'

import type { FC, ReactNode } from 'react'

type PropsType = {
  children: ReactNode
}

const Application: FC<PropsType> = ({ children }: PropsType) => {
  const classes = useStyles()

  return (
    <div className={classes.application}>
      <div className={classes.applicationInner}>{children}</div>
    </div>
  )
}

export default Application
